import db from "../driverappdb";

export const FeedbackRepository = {
    getFeedback: (dropId) => db.feedback.where({dropId: dropId}).toArray(),
    getFeedbackItems: (feedbackKey) => {
        return db.feedbackitems.get(feedbackKey)
            .then(feedbackConfigItem => feedbackConfigItem.content);
    }
};